/**
 * WEB発券（お客様向け）
 */
document.addEventListener('DOMContentLoaded', function() {
  const webIssueBtn = document.getElementById('webIssueTicketButton');
  const resultBox = document.getElementById('webIssueResult');
  const customerIdEl = document.getElementById('currentCustomerId');
  const customerNameEl = document.getElementById('currentCustomerName');

  // デバッグは控えめに（グローバルフラグで制御）
  function logDebug(msg) {
    try {
      if (typeof window !== 'undefined' && window.POPUP_DEBUG_ENABLED) {
        const text = `[WebIssue] ${new Date().toLocaleTimeString()} ${msg}`;
        console.log(text);
        if (resultBox) {
          const line = document.createElement('div');
          line.style.fontSize = '12px';
          line.style.color = '#666';
          line.textContent = text;
          resultBox.appendChild(line);
        }
      }
    } catch (_) {}
  }

  // 汎用: フェッチの指数バックオフ付きリトライ
  async function fetchWithRetry(url, options, cfg) {
    const retries = (cfg && typeof cfg.retries === 'number') ? cfg.retries : 3;
    const base = (cfg && typeof cfg.baseMs === 'number') ? cfg.baseMs : 200; // 200msから指数
    const retryOn = (cfg && Array.isArray(cfg.retryOn)) ? cfg.retryOn : [429, 502, 503];
    const label = (cfg && cfg.label) ? cfg.label : 'request';
    for (let attempt = 0; attempt <= retries; attempt++) {
      const tryNo = attempt + 1;
      const res = await fetch(url, options).catch(err => ({ ok: false, networkError: err }));
      if (res && res.ok) return res;
      const status = res && !res.networkError ? res.status : 'network';
      const shouldRetry = (res && res.networkError) || retryOn.includes(status);
      logDebug(`${label}: attempt ${tryNo} failed (${status}).${shouldRetry && tryNo <= retries ? ' retrying...' : ''}`);
      if (!shouldRetry || tryNo > retries) {
        if (res && !res.networkError) return res; // 最終失敗レスポンスを返す
        throw (res && res.networkError) || new Error('Network error');
      }
      const delay = Math.round(base * Math.pow(2, attempt) + Math.random() * 100); // 指数 + ジッター
      await new Promise(r => setTimeout(r, delay));
    }
  }

  logDebug('スクリプト読込完了: web-issue-ticket.js');
  if (!webIssueBtn) {
    logDebug('webIssueTicketButton が見つかりません。未発券状態ではない/ID不一致の可能性');
    return;
  }
  logDebug('webIssueTicketButton を検出');
  logDebug(`currentCustomerId: ${customerIdEl?.value ?? '(未取得)'}`);

  // 事前に当日の発券上限を確認し、超過していればボタンを非表示
  async function precheckDailyLimitAndToggleButton() {
    try {
      const { dailyLimit, todayCount } = await getLimitAndTodayCount();
      if (dailyLimit > 0 && todayCount >= dailyLimit) {
        if (resultBox) {
          // 既存ログは残しつつ、上限メッセージだけを別要素で表示
          let limitMsg = resultBox.querySelector('.limit-message');
          if (!limitMsg) {
            limitMsg = document.createElement('div');
            limitMsg.className = 'limit-message';
            resultBox.prepend(limitMsg);
          }
          limitMsg.style.color = '#F44336';
          limitMsg.style.fontWeight = 'bold';
          limitMsg.textContent = `本日の発券上限(${dailyLimit})に達しました。`;
        }
        if (webIssueBtn) {
          webIssueBtn.style.display = 'none';
        }
      } else {
        // 上限未達なら上限メッセージのみ除去（ログは保持）
        if (resultBox) {
          const limitMsg = resultBox.querySelector('.limit-message');
          if (limitMsg) limitMsg.remove();
        }
      }
    } catch (e) {
      logDebug('上限事前チェック失敗: ' + e.message);
    }
  }
  precheckDailyLimitAndToggleButton();
  window.addEventListener('focus', precheckDailyLimitAndToggleButton);

  // 既存の整理券番号から次番号を算出
  async function getNextTicketNumber() {
    try {
      const query = `query GetAllTickets {\n  metaobjects(first: 100, type: "popup_reservnumber") {\n    edges {\n      node {\n        fields {\n          key\n          value\n        }\n      }\n    }\n  }\n}`;
      const apiEndpoint = 'https://c18pge9gzj.execute-api.ap-northeast-3.amazonaws.com/shopify_hj_metaobject_query?timestamp=' + new Date().getTime();
      logDebug('採番APIへリクエスト開始: ' + apiEndpoint);
      const response = await fetchWithRetry(apiEndpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ query })
      }, { retries: 3, baseMs: 200, retryOn: [429, 502, 503], label: 'getNextTicketNumber' });
      logDebug(`採番APIレスポンス: ${response.status} ${response.statusText}`);
      if (!response.ok) throw new Error(`採番APIエラー: ${response.status} ${response.statusText}`);
      let data;
      try {
        data = await response.json();
      } catch (e) {
        logDebug('採番API JSONパース失敗: ' + e.message);
        throw e;
      }

      let latestNumber = 0;
      let prefix = '';
      const edges = data?.data?.metaobjects?.edges || [];
      logDebug(`採番APIチケット件数: ${edges.length}`);
      for (const edge of edges) {
        const fields = edge?.node?.fields || [];
        const infoField = fields.find(f => f.key === 'info');
        const value = infoField?.value || '';
        // パターン: A001 などアルファベット+数字 or 数字のみ
        const m1 = value.match(/^([A-Za-z]+)(\d+)$/);
        const m2 = value.match(/^(\d+)$/);
        if (m1) {
          const num = parseInt(m1[2], 10);
          if (!isNaN(num) && num > latestNumber) { latestNumber = num; prefix = m1[1]; }
        } else if (m2) {
          const num = parseInt(m2[1], 10);
          if (!isNaN(num) && num > latestNumber) { latestNumber = num; }
        }
      }
      const next = latestNumber + 1;
      const nextNumber = `${prefix}${String(next).padStart(3, '0')}`;
      logDebug('次番号: ' + nextNumber);
      return nextNumber;
    } catch (e) {
      // フォールバック
      logDebug('採番失敗。フォールバック 001 を使用: ' + e.message);
      return '001';
    }
  }

  // 設定と当日発券数を取得し、上限チェックを行う
  async function getLimitAndTodayCount() {
    const query = `query GetSettingsAndTickets {\n  settings: metaobjects(first: 1, type: "popup_reservnumber_settings", query: "handle:common") {\n    edges {\n      node {\n        handle\n        fields { key value }\n      }\n    }\n  }\n  tickets: metaobjects(first: 100, type: "popup_reservnumber") {\n    edges {\n      node {\n        fields { key value }\n      }\n    }\n  }\n}`;
    const apiEndpoint = 'https://c18pge9gzj.execute-api.ap-northeast-3.amazonaws.com/shopify_hj_metaobject_query?timestamp=' + new Date().getTime();
    logDebug('上限チェックAPIへリクエスト開始: ' + apiEndpoint);
    const response = await fetchWithRetry(apiEndpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ query })
    }, { retries: 3, baseMs: 200, retryOn: [429, 502, 503], label: 'getLimitAndTodayCount' });
    logDebug(`上限チェックAPIレスポンス: ${response.status} ${response.statusText}`);
    if (!response.ok) throw new Error(`設定取得エラー: ${response.status} ${response.statusText}`);
    const data = await response.json();
    if (data?.errors) {
      logDebug('GraphQL errors: ' + JSON.stringify(data.errors));
    }

    // 設定の抽出
    const settingsEdges = data?.data?.settings?.edges || [];
    const settingsNode = settingsEdges[0]?.node;
    const settingsHandle = settingsNode?.handle || '(unknown)';
    const settingsFields = settingsNode?.fields || [];
    // max_reserve_number: 未設定→0(無制限)、0→無制限
    const limitRaw = (settingsFields.find(f => f.key === 'max_reserve_number')?.value ?? '').toString().trim();
    let dailyLimit = 0;
    if (limitRaw !== '') {
      const parsed = parseInt(limitRaw, 10);
      if (!isNaN(parsed)) dailyLimit = parsed;
    }
    if (dailyLimit < 0) dailyLimit = 0;
    logDebug(`設定ハンドル:${settingsHandle} / 取得上限:${dailyLimit}`);

    // 当日カウント（statusに依存せず、当日作成エントリー総数）
    const ticketEdges = data?.data?.tickets?.edges || [];
    logDebug('取得チケット件数: ' + ticketEdges.length);
    const todayStr = new Date().toLocaleDateString('sv-SE'); // YYYY-MM-DD (ローカルTZ)
    let todayCount = 0;
    for (const edge of ticketEdges) {
      const node = edge?.node || {};
      const fields = node.fields || [];
      const timeVal = fields.find(f => f.key === 'time')?.value;
      if (!timeVal) continue;
      // 日付一致判定（ローカルTZで比較）
      const d = new Date(timeVal);
      const dStr = isNaN(d.getTime()) ? '' : d.toLocaleDateString('sv-SE');
      if (dStr !== todayStr) continue;
      todayCount += 1;
    }

    logDebug(`上限:${dailyLimit} / 当日発券数:${todayCount}`);
    return { dailyLimit, todayCount };
  }

  // 当日の発券上限を超えていればエラーを投げる
  async function enforceDailyLimitOrThrow() {
    const { dailyLimit, todayCount } = await getLimitAndTodayCount();
    if (dailyLimit > 0 && todayCount >= dailyLimit) {
      throw new Error(`本日の発券上限(${dailyLimit})に達しました。`);
    }
  }

  async function createTicket(nextNumber, customerId) {
    // 現在時刻 ISO
    const nowIso = new Date().toISOString();
    // 必要最低限のフィールドで発券
    const nameFromLiquid = (customerNameEl?.value || '').toString().trim();
    const nameValue = nameFromLiquid || 'WEB';
    const requestData = {
      type: "popup_reservnumber",
      fields: [
        { key: "info", value: nextNumber, type: "single_line_text_field" },
        { key: "status", value: JSON.stringify(["wait"]), type: "single_line_text_field" },
        { key: "name", value: nameValue, type: "single_line_text_field" },
        { key: "time", value: nowIso, type: "date_time_field" },
        { key: "menu", value: "WEB", type: "single_line_text_field" },
        { key: "timerequired", value: "20", type: "number_integer" },
        { key: "customerid", value: customerId, type: "single_line_text_field" }
      ]
    };

    const apiEndpoint = 'https://3ljs7n4356.execute-api.ap-northeast-3.amazonaws.com/shopify_hj_metaobject_entry?timestamp=' + new Date().getTime();
    logDebug('発券APIへ送信: ' + apiEndpoint);
    logDebug('発券リクエスト: ' + JSON.stringify(requestData));
    const response = await fetchWithRetry(apiEndpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Origin': window.location.origin
      },
      mode: 'cors',
      credentials: 'omit',
      body: JSON.stringify(requestData)
    }, { retries: 3, baseMs: 200, retryOn: [429, 502, 503], label: 'createTicket' });
    logDebug(`発券APIレスポンス: ${response.status} ${response.statusText}`);
    if (!response.ok) throw new Error(`発券APIエラー: ${response.status} ${response.statusText}`);
    let json;
    try {
      json = await response.json();
    } catch (e) {
      logDebug('発券API JSONパース失敗: ' + e.message);
      throw e;
    }
    logDebug('発券APIレスポンス本文: ' + JSON.stringify(json));
    return json;
  }

  webIssueBtn.addEventListener('click', async function() {
    try {
      logDebug('クリック: WEBで発券');
      const customerId = (customerIdEl?.value || '').toString().trim();
      logDebug('顧客ID: ' + (customerId || '(空)'));
      if (!customerId) {
        throw new Error('顧客IDを取得できませんでした。ログイン状態をご確認ください。');
      }

      // UIロック
      webIssueBtn.disabled = true;
      webIssueBtn.textContent = '発券中…（リトライあり）';
      if (resultBox) { resultBox.style.color = '#2196F3'; resultBox.textContent = '発券中…（必要に応じて自動リトライします）'; }
      // 最小表示時間: 2000ms（体感をわかりやすく）
      if (window.showLoadingOverlay) window.showLoadingOverlay('WEB発券処理中です…', 2000);

      // 1日の発券上限チェック
      await enforceDailyLimitOrThrow();

      // 既存の未完了チケットを持っていないかはLiquid側で判定済み（ボタン表示条件）
      const nextNumber = await getNextTicketNumber();
      logDebug('発行番号: ' + nextNumber);

      const result = await createTicket(nextNumber, customerId);
      if (result && result.success) {
        if (resultBox) {
          resultBox.style.color = '#4CAF50';
          resultBox.textContent = `✅ 発券しました（番号: ${nextNumber}）`;
        }
        if (window.hideLoadingOverlay) window.hideLoadingOverlay();
        // 反映のためリロード（少し長めに待って視認性を確保）
        setTimeout(() => window.location.reload(), 2500);
      } else {
        const msg = result && result.error ? result.error : '不明なエラー';
        throw new Error(msg);
      }
    } catch (e) {
      logDebug('エラー: ' + e.message);
      if (resultBox) { resultBox.style.color = '#F44336'; resultBox.textContent = `❌ ${e.message}`; }
      if (window.hideLoadingOverlay) window.hideLoadingOverlay();
    } finally {
      webIssueBtn.disabled = false;
      webIssueBtn.textContent = 'WEBで発券';
    }
  });
});
